"use client";

import { SignIn } from "@clerk/nextjs";
import { useEffect } from "react";
import "../../auth.css";

import { optionovaClerkAppearance } from "../../../lib/clerk-appearance";

export default function SignInPage() {
  useEffect(() => {
    const focusIdentifier = () => {
      const activeElement = document.activeElement;
      const canMoveFocus =
        !activeElement || activeElement === document.body || activeElement === document.documentElement;
      const identifier = document.querySelector<HTMLInputElement>(
        'input[name="identifier"], input#identifier-field',
      );

      if (!canMoveFocus || !identifier) return false;

      identifier.focus();
      return true;
    };

    if (focusIdentifier()) return;

    const observer = new MutationObserver(() => {
      if (focusIdentifier()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    const timeout = window.setTimeout(() => observer.disconnect(), 5000);
    return () => {
      observer.disconnect();
      window.clearTimeout(timeout);
    };
  }, []);

  return (
    <main className="auth-page">
      <div className="auth-page__content">
        <div className="auth-page__panel">
          <div className="auth-page__brand">
            <img src="/icon.svg" alt="" width="72" height="72" />
            <strong>Optionova</strong>
            <span>Your Book of Business</span>
          </div>
          <SignIn appearance={optionovaClerkAppearance} fallbackRedirectUrl="/app/overview" />
        </div>
      </div>
    </main>
  );
}
